(function (Translator) {
    // sq
    Translator.add("address", "Adresa:", "PayseraMapBundle", "sq");
    Translator.add("friday", "E premte", "PayseraMapBundle", "sq");
    Translator.add("monday", "E h\u00ebn\u00eb", "PayseraMapBundle", "sq");
    Translator.add("no_results", "Nuk ka rezultate", "PayseraMapBundle", "sq");
    Translator.add("saturday", "E shtun\u00eb", "PayseraMapBundle", "sq");
    Translator.add("search_placeholder", "Vendosni nj\u00eb fragment", "PayseraMapBundle", "sq");
    Translator.add("service.cash_in", "Cash-in", "PayseraMapBundle", "sq");
    Translator.add("service.cash_out", "Cash-out", "PayseraMapBundle", "sq");
    Translator.add("service.identification", "Identifikimi", "PayseraMapBundle", "sq");
    Translator.add("service.pay", "Pagesat", "PayseraMapBundle", "sq");
    Translator.add("services", "Sh\u00ebrbime:", "PayseraMapBundle", "sq");
    Translator.add("sunday", "E diel", "PayseraMapBundle", "sq");
    Translator.add("thursday", "E enjte", "PayseraMapBundle", "sq");
    Translator.add("tuesday", "E mart\u00eb", "PayseraMapBundle", "sq");
    Translator.add("wednesday", "E m\u00ebrkur\u00eb", "PayseraMapBundle", "sq");
    Translator.add("working_hours", "Or\u00ebt e pun\u00ebs:", "PayseraMapBundle", "sq");
})(Translator);
